<div class="section-title">
    <fa-icon class="me-1" [icon]="options.icon"></fa-icon>
    {{ options.title | translate }}
</div>